<template>
    <div class="vertical-widget">
        <div class="widget-contents-container ">
            <div class="widget-header">
                <h3>Edit Vertical</h3>
                <div class="svg-container widget-close-button" @click="closeWidget">
                    <widget-close-svg />
                </div>
            </div>
            <div class="content-wrapper">
                <loading-screen-svg v-if="isLoading" />
                <div class="form-wrapper" v-else>
                    <div class="input-container">
                        <app-input
                            v-model="vertical.name"
                            placeholder="Name" 
                            :label="' Vertical Name'"
                            :isValid="!submitted || $v.vertical.name.required"
                            :error="`Name is required`"
                        />
                    </div>
                </div>
            </div> 
            <div class="widget-footer">
                <div class="cancel-container">
                    <app-button class="cancel-btn transparent-btn" @click="closeWidget">
                        Cancel
                    </app-button>
                </div>
                <div class="action-container">
                    <app-button @click="save()">Save</app-button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
const AppButton = () => import('@/components/common/app-button.vue');
const WidgetCloseSvg = () => import('@/components/svg/quick-add/widget-close-svg.vue');
const AppInput = () => import('@/components/common/app-input.vue');
const LoadingScreenSvg = () => import('@/components/svg/loading-screen-svg');

import EventBus from '@/scripts/event-bus.js';
import { required} from 'vuelidate/lib/validators';

export default {
    name: 'vertical-widget',

    props: {
        widget: {
            type: Object,
            required: true
        }
    },

    components: {
        'app-button': AppButton,
        'widget-close-svg': WidgetCloseSvg,
        'app-input': AppInput,
        'loading-screen-svg': LoadingScreenSvg,
    },

    data() {
        return {
            submitted: false,
            isLoading: true,
            vertical: {
                id: this.widget.verticalId,
                clientId: this.widget.clientId,
                name: null,
            },
        }
    },

    validations: {
        vertical: {
            name: {
                required
            },
        },
    },

    methods: {
        closeWidget() {
            EventBus.$emit('close-widget', this.widget);
        },

        save() {
            this.submitted = true;
            this.$v.$touch();

            if (this.$v.$invalid) {
                return;
            }

            if(this.vertical.id) {
                this.patch();
            } 
            else {
                this.post();
            }
        },

        patch() {
            this.isLoading = true;

            var changes = [{
                'name': 'Name',
                'value': this.vertical.name
            }];

            this.$api
                .patch(`/api/Verticals/${ this.vertical.id }`, changes)
                .then(response => {
                    this.$helpers.showSuccessNotification('Your vertical has been successfully updated.');
                    EventBus.$emit('vertical:update');
                    this.closeWidget();
                })
                .catch((error) => {
                    this.isLoading = false;
                    this.$helpers.showFailNotification('An error occurred while updating your vertical.', { error });
                });
        },

        post() {
            this.isLoading = true;

            var vertical = {
                Name: this.vertical.name,
                ClientId: this.vertical.clientId,
            };

            this.$api
                .post(`/api/Verticals`, vertical)
                .then(response => {
                    this.$helpers.showSuccessNotification('Your vertical has been successfully created.');
                    EventBus.$emit('vertical:update');
                    this.closeWidget();
                })
                .catch((error) => {
                    this.isLoading = false;
                    this.$helpers.showFailNotification('An error occurred while creating your vertical.', { error });
                });
        },

        getVertical () {
            this.isLoading = true;

            this.$api
                .get(`/service/Verticals?$filter=Id eq ${ this.vertical.id }`)
                .then(response => {
                    this.vertical.id = response.data.value[0].Id;
                    this.vertical.name = response.data.value[0].Name;
                })
                .catch((error) => {
                    this.$helpers.showFailNotification('An error occurred while fetching your vertical.', { error });
                })
                .finally(() => {
                    this.isLoading = false;
                });
        }
    },

    created() {
        if (this.vertical.id) {
            this.getVertical();
        }
        else {
            this.isLoading = false;
        }
    }
}
</script>

<style>
.vertical-widget .form-wrapper {
    display: flex;
    align-items: center;
}

.vertical-widget .widget-company-vertical-settings .transparent-btn {
    background: transparent;
    color: #877D88;
    border: none;
}

.vertical-widget .widget-company-vertical-settings .transparent-btn:hover {
    background: #E1E0E5;
}

.vertical-widget .app-input input {
        padding: 8px 15px;
}

.vertical-widget .cancel-btn {
    background: transparent;
    color: #877D88;
    border: none;
}

.vertical-widget label {
    margin-bottom: 13px;
}

.vertical-widget .input-container {
    width: 100%;
}
</style>